import React, { useState, useEffect, useRef } from 'react';
import { Button, Card, Row, Col, Form, Alert, Modal, Dropdown } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MailTemplateService } from '../../../Services/Axios/Api';

const defaultTemplate = `
<!DOCTYPE html>
<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Invoice</title>
    <style>
        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            line-height: 1.6;
            color: #333;
            margin: 0;
            padding: 0;
        }
        .container {
            max-width: 600px;
            margin: 0 auto;
            padding: 20px;
        }
        .header {
            text-align: center;
            padding: 20px 0;
            border-bottom: 2px solid #eee;
        }
        .logo {
            max-width: 150px;
            height: auto;
        }
        .invoice-details {
            margin: 30px 0;
            padding: 20px;
            background: #f9f9f9;
            border-radius: 5px;
        }
        .invoice-table {
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0;
        }
        .invoice-table th,
        .invoice-table td {
            padding: 12px;
            text-align: left;
            border-bottom: 1px solid #ddd;
        }
        .invoice-table th {
            background-color: #f5f5f5;
        }
        .total {
            text-align: right;
            margin-top: 20px;
            font-size: 1.2em;
            font-weight: bold;
        }
        .footer {
            margin-top: 30px;
            padding-top: 20px;
            border-top: 2px solid #eee;
            text-align: center;
            font-size: 0.9em;
            color: #666;
        }
        .button {
            display: inline-block;
            padding: 12px 24px;
            background-color: #4CAF50;
            color: white;
            text-decoration: none;
            border-radius: 5px;
            margin: 20px 0;
        }
        .payment-info {
            background: #f5f5f5;
            padding: 15px;
            border-radius: 5px;
            margin: 20px 0;
        }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <!--<img src="[LogoUrl]" alt="Company Logo" class="logo">-->
            <h1>INVOICE</h1>
        </div>

        <div class="invoice-details">
            <p><strong>Invoice Number:</strong> [InvoiceNumber]</p>
            <p><strong>Date:</strong> [InvoiceDate]</p>
            <p><strong>Due Date:</strong> [DueDate]</p>
        </div>

        <div class="payment-info">
            <h3>Payment Information</h3>
            <p><strong>Amount Due:</strong> [Amount] [Currency]</p>
            <p><strong>Payment Method:</strong> [PaymentMethod]</p>
            <p><strong>Status:</strong> [Status]</p>
        </div>

        <table class="invoice-table">
            <thead>
                <tr>
                    <th>Description</th>
                    <th>Amount</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>[Description]</td>
                    <td>[Amount] [Currency]</td>
                </tr>
            </tbody>
        </table>

        <div class="total">
            <p>Total Amount: [Amount] [Currency]</p>
        </div>

        <div style="text-align: center;">
            <a href="[PaymentUrl]" class="button">Pay Now</a>
        </div>

        <div class="footer">
            <p>Thank you for your business!</p>
            <!--<p>If you have any questions, please contact us at [ContactEmail]</p>-->
            <!--<p>[CompanyName] | [CompanyAddress]</p>-->
        </div>
    </div>
</body>
</html> 
`;
const defaultRechargeTemplate = `
<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Subscription Renewal</title>
    <style>
        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            line-height: 1.6;
            color: #333;
            margin: 0;
            padding: 0;
        }
        .container {
            max-width: 600px;
            margin: 0 auto;
            padding: 20px;
        }
        .header {
            text-align: center;
            padding: 20px 0;
            border-bottom: 2px solid #eee;
        }
        .logo {
            max-width: 150px;
            height: auto;
        }
        .notice {
            margin: 30px 0;
            padding: 20px;
            background: #f9f9f9;
            border-radius: 5px;
            text-align: center;
        }
        .notice h2 {
            color: #4CAF50;
            margin-bottom: 10px;
        }
        .details {
            margin: 20px 0;
            background: #f5f5f5;
            padding: 15px;
            border-radius: 5px;
        }
        .details p {
            margin: 8px 0;
        }
        .footer {
            margin-top: 30px;
            padding-top: 20px;
            border-top: 2px solid #eee;
            text-align: center;
            font-size: 0.9em;
            color: #666;
        }
        .button {
            display: inline-block;
            padding: 12px 24px;
            background-color: #4CAF50;
            color: white;
            text-decoration: none;
            border-radius: 5px;
            margin-top: 20px;
        }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <h1>Subscription Renewal Notice</h1>
        </div>

        <div class="notice">
            <h2>Your subscription has been successfully renewed!</h2>
            <p>The amount has been deducted from your selected payment method.</p>
        </div>

        <div class="details">
            <p><strong>Invoice Number:</strong> [InvoiceNumber]</p>
            <p><strong>Invoice Date:</strong> [InvoiceDate]</p>
            <p><strong>Due Date:</strong> [DueDate]</p>
            <p><strong>Description:</strong> [Description]</p>
            <p><strong>Amount Charged:</strong> [Amount] [Currency]</p>
            <p><strong>Payment Method:</strong> [PaymentMethod]</p>
            <p><strong>Status:</strong> [Status]</p>
        </div>



        <div class="footer">
            <p>Thank you for your continued subscription with.</p> 
        </div>
    </div>
</body>
</html>
`;
const defaultThankYouTemplate = `
<!DOCTYPE html>
<html lang="ar" dir="rtl">
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>شكرًا لتبرعكم</title>
    <style>
        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            line-height: 1.6;
            color: #333;
            margin: 0;
            padding: 0;
            direction: rtl;
            text-align: right;
            background: #fafafa;
        }
        .container {
            max-width: 700px;
            margin: 0 auto;
            padding: 20px;
            background: white;
        }
        .header {
            text-align: center;
            padding: 20px 0;
            border-bottom: 2px solid #eee;
        }
        .logo {
            max-width: 150px;
            height: auto;
        }
        .notice {
            margin: 30px 0;
            padding: 20px;
            background: #f1fff2;
            border: 1px solid #d4efd6;
            border-radius: 5px;
            text-align: center;
        }
        .notice h2 {
            color: #4CAF50;
            margin-bottom: 10px;
        }
        table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 25px;
            background: #f9f9f9;
        }
        table th, table td {
            border: 1px solid #ddd;
            padding: 12px;
            text-align: center;
        }
        table th {
            background: #4CAF50;
            color: white;
        }
        .footer {
            margin-top: 30px;
            padding-top: 20px;
            border-top: 2px solid #eee;
            text-align: center;
            font-size: 0.9em;
            color: #666;
        }
    </style>
</head>
<body>
    <div class="container">

        <div class="header">
            <img src="[LogoUrl]" 
                 alt="شعار الشركة" class="logo">
        </div>

        <div class="notice">
            <h2>شكرًا لتبرعكم!</h2>
            <p>تم استلام تبرعكم بنجاح، ونقدّر مساهمتكم الكريمة.</p>
        </div>

        <table>
            <tr>
                <th>اسم المتبرع</th>
                <td>[DonorName]</td>
            </tr>
            <tr>
                <th>البريد الإلكتروني</th>
                <td>[Email]</td>
            </tr>
            <tr>
                <th>الحملة</th>
                <td>[CampaignName]</td>
            </tr>
            <tr>
                <th>رقم الفاتورة</th>
                <td>[InvoiceNumber]</td>
            </tr>
            <tr>
                <th>تاريخ الدفع</th>
                <td>[PaymentDate]</td>
            </tr>
            <tr>
                <th>الوصف</th>
                <td>[Description]</td>
            </tr>
            <tr>
                <th>المبلغ</th>
                <td>[Amount] [Currency]</td>
            </tr>
            <tr>
                <th>طريقة الدفع</th>
                <td>[PaymentMethod]</td>
            </tr>
            <tr>
                <th>الحالة</th>
                <td>[Status]</td>
            </tr>
        </table>

        <div class="footer">
            <p>شكرًا لكم مرة أخرى، ونسعد دومًا بثقتكم ودعمكم.</p>
        </div>

    </div>
</body>
</html>

`;
const MailTemplateEditor = () => {
  const [htmlContent, setHtmlContent] = useState(defaultTemplate);
  const [showPreview, setShowPreview] = useState(false);
  const [templateName, setTemplateName] = useState('');
  const [subject, setSubject] = useState('Invoice for [InvoiceNumber]');
  const [isLoading, setIsLoading] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [template, setTemplate] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const iframeRef = useRef(null);

  // Available placeholders for reference
  const placeholders = [
    '[LogoUrl]', '[InvoiceNumber]', '[InvoiceDate]', '[DueDate]',
    '[Amount]', '[Currency]', '[PaymentMethod]', '[Status]',
    '[Description]', '[PaymentUrl]', '[ContactEmail]', '[CompanyName]',
    '[CompanyAddress]'
  ];

  // Update iframe content when htmlContent changes
  useEffect(() => {
    if (iframeRef.current && showPreview) {
      const iframe = iframeRef.current;
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(htmlContent);
      iframeDoc.close();
    }
  }, [htmlContent, showPreview]);

  const fetchAllTemplates = async () => {
    try {
      const allTemplates = await MailTemplateService.getMailTemplates();
      setTemplates(allTemplates);
    } catch (error) {
      console.error('Error fetching all templates:', error);
      toast.error('Failed to fetch templates');
    }
  };

  const fetchTemplate = async (templateId) => {
    try {
      const templateData = await MailTemplateService.getMailTemplateById(templateId);
      if (templateData) {
        setHtmlContent(templateData.body || defaultTemplate);
        setSubject(templateData.subject || 'Invoice for [InvoiceNumber]');
        setTemplateName(templateData.templateName || '');
        setTemplate(templateData);
        setIsEditing(true);
      }
    } catch (error) {
      console.error('Error fetching template:', error);
      toast.error('Failed to fetch template');
    }
  };

  useEffect(() => {
    fetchAllTemplates();
  }, []);

  const handleTemplateSelect = (templateId) => {
    setSelectedTemplateId(templateId);
    fetchTemplate(templateId);
  };

  const handleNewTemplate = () => {
    setSelectedTemplateId(null);
    setHtmlContent(defaultTemplate);
    setSubject('Invoice for [InvoiceNumber]');
    setTemplateName('');
    setTemplate(null);
    setIsEditing(false);
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      const templateData = {
        templateName: templateName,
        subject: subject,
        body: htmlContent,
      };

      if (template && template.id) {
        // Update existing template
        await MailTemplateService.updateMailTemplate(template.id, templateData);
        toast.success('Template updated successfully!');
      } 
      
      // else {
      //   // Create new template
      //   const newTemplate = await MailTemplateService.createMailTemplate(templateData);
      //   setTemplate(newTemplate);
      //   setSelectedTemplateId(newTemplate.id);
      //   setIsEditing(true);
      //   toast.success('Template created successfully!');
      // }
      
      // Refresh templates list
      fetchAllTemplates();
    } catch (error) {
      toast.error('Failed to save template. Please try again.');
      console.error('Error saving template:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReset = () => {
    if(getSelectedTemplateName()=="Invoice Template") {
      setHtmlContent(defaultTemplate);
      setSubject('Invoice for [InvoiceNumber]');

    } else if(getSelectedTemplateName()=="Recharge Template") {
      setHtmlContent(defaultRechargeTemplate);
      setSubject('Recharge Successfully');

    } else if(getSelectedTemplateName()=="Thanks For Payment Template") {
      setHtmlContent(defaultThankYouTemplate);
      setSubject('Thank You for Your Payment');
    }
    setShowResetModal(false);
    toast.info('Template reset to default');
  };

  const insertPlaceholder = (placeholder) => {
    const textarea = document.getElementById('html-editor');
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const newContent = htmlContent.substring(0, start) + placeholder + htmlContent.substring(end);
    setHtmlContent(newContent);
    
    // Set cursor position after the inserted placeholder
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + placeholder.length, start + placeholder.length);
    }, 0);
  };

  const getSelectedTemplateName = () => {
    if (!selectedTemplateId) return 'Select a template';
    const selectedTemplate = templates.find(t => t.id === selectedTemplateId);
    return selectedTemplate ? selectedTemplate.templateName : 'Select a template';
  };

  return (
    <div className="container mt-4">
      {/* Template Selector at Top */}
      <Card className="mb-4">
        <Card.Header>
          <h5 className="mb-0">Template Selection</h5>
        </Card.Header>
        <Card.Body>
          <Row className="align-items-center">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Select Template</Form.Label>
                <Dropdown>
                  <Dropdown.Toggle variant="outline-primary" id="template-dropdown" className="w-100">
                    {getSelectedTemplateName()}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="w-100">
                    
                    <Dropdown.Divider />
                    {templates.map((template) => (
                      <Dropdown.Item 
                        key={template.id}
                        onClick={() => handleTemplateSelect(template.id)}
                        active={selectedTemplateId === template.id}
                      >
                        {template.templateName || 'Unnamed Template'}
                        <br />
                        <small className="text-muted">{template.subject}</small>
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Form.Group>
            </Col>
            <Col md={6} className="text-end">
              <div className="d-flex gap-2 justify-content-end">
                {isEditing && (
                  <>
                    <Button 
                      variant="outline-secondary" 
                      onClick={() => setShowPreview(!showPreview)}
                    >
                      {showPreview ? 'Hide Preview' : 'Show Preview'}
                    </Button>
                    <Button 
                      variant="outline-warning" 
                      onClick={() => setShowResetModal(true)}
                    >
                      Reset to Default
                    </Button>
                    <Button 
                      variant="primary" 
                      onClick={handleSave}
                      disabled={isLoading}
                    >
                      {isLoading ? 'Saving...' : 'Save Template'}
                    </Button>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Editor and Preview Section */}
      {isEditing && (
        <Row>
          <Col lg={showPreview ? 6 : 12}>
            <Card className="mb-3">
              <Card.Header>
                <Row>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Template Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={templateName}
                        disabled
                        // onChange={(e) => setTemplateName(e.target.value)}
                        placeholder="Enter template name"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Email Subject</Form.Label>
                      <Form.Control
                        type="text"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        placeholder="Enter email subject"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body>
                <Form.Group className="mb-3">
                  <Form.Label>Available Placeholders</Form.Label>
                  <div className="d-flex flex-wrap gap-1 mb-3">
                    {placeholders.map((placeholder, index) => (
                      <Button
                        key={index}
                        size="sm"
                        variant="outline-info"
                        onClick={() => insertPlaceholder(placeholder)}
                        style={{ fontSize: '0.8rem' }}
                      >
                        {placeholder}
                      </Button>
                    ))}
                  </div>
                </Form.Group>
                
                <Form.Group>
                  <Form.Label>HTML Template</Form.Label>
                  <Form.Control
                    as="textarea"
                    id="html-editor"
                    rows={25}
                    value={htmlContent}
                    onChange={(e) => setHtmlContent(e.target.value)}
                    style={{ fontFamily: 'monospace', fontSize: '0.9rem' }}
                  />
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>

          {showPreview && (
            <Col lg={6}>
              <Card>
                <Card.Header>Preview</Card.Header>
                <Card.Body style={{ padding: 0 }}>
                  <iframe
                    ref={iframeRef}
                    title="Email Template Preview"
                    style={{
                      width: '100%',
                      height: '600px',
                      border: 'none',
                      backgroundColor: 'white'
                    }}
                  />
                </Card.Body>
              </Card>
            </Col>
          )}
        </Row>
      )}

      {!isEditing && (
        <Alert variant="info" className="mt-3">
          <strong>Instructions:</strong>
          <ul className="mb-0 mt-2">
            <li>Select a template from the dropdown to edit it</li>
            <li>Click "New Template" to create a new template</li>
            <li>Use the available placeholders to insert dynamic content</li>
          </ul>
        </Alert>
      )}

      {isEditing && (
        <Alert variant="info" className="mt-3">
          <strong>Tips:</strong>
          <ul className="mb-0 mt-2">
            <li>Use the placeholder buttons to insert dynamic content markers</li>
            <li>Click "Show Preview" to see how your template will look</li>
            <li>Make sure to test your template with actual data before sending</li>
            <li>The template supports full HTML and CSS styling</li>
            <li>The preview is isolated in an iframe to prevent styling conflicts</li>
          </ul>
        </Alert>
      )}

      {/* Reset Confirmation Modal */}
      <Modal show={showResetModal} onHide={() => setShowResetModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Reset</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to reset to the default template? This will lose all your changes.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowResetModal(false)}>
            Cancel
          </Button>
          <Button variant="warning" onClick={handleReset}>
            Reset Template
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer position="top-right" />
    </div>
  );
};

export default MailTemplateEditor;
